import { IoLocationSharp } from "react-icons/io5";
import { FiShoppingCart } from "react-icons/fi";
import { IoMdMail } from "react-icons/io";
import { ServiceIcon } from "@/components/svgs";

export const renderIcon = (item, styleClass = "self-center") => {
  const label = (item?.fields?.label || "").toLowerCase();
  const url = (item?.fields?.url || "").toLowerCase();
  if (/store/.test(url)) {
    return (
      <div className={`${styleClass}`}>
        <IoLocationSharp size={18} />
      </div>
    );
  }
  if (/contact/.test(url)) {
    return (
      <div className={`${styleClass}`}>
        <IoMdMail size={18} />
      </div>
    );
  }
  if (/service/.test(url)) {
    return (
      <div className={`${styleClass}`}>
        <ServiceIcon width={18} height={18} color="#bebebe" />
      </div>
    );
  }
  if (/shop/.test(url) || /shop/.test(label)) {
    return (
      <div className={`${styleClass}`}>
        <FiShoppingCart size={18} />
      </div>
    );
  }
  return <>&nbsp;</>;
};
